import { faKey, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import { useContext, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios, { AxiosError } from 'axios';
import { AuthContext } from 'providers/AuthProvider';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ConfigConstants } from 'utils/config';
import { toastConfig } from 'utils/toastConfig';

const SignInForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const grantType = 'password';
  const auth = useContext(AuthContext) || {
    token: null,
    loading: false,
    error: null,
    dispatch: () => {}
  };
  const { token, dispatch } = auth;
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate('/');
    }
  }, [token, navigate]);

  const handleSubmit = async () => {
    try {
      dispatch({ type: 'LOGIN_START' });
      const res = await axios.post(`${ConfigConstants.baseUrl}token`, {
        email,
        password,
        grantType
      });
      dispatch({ type: 'LOGIN_SUCCESS', payload: res.data });
      toast.success('Login Success', {
        ...toastConfig,
        autoClose: 2000
      });
      navigate('/');
    } catch (error) {
      if (error instanceof AxiosError) {
        dispatch({
          type: 'LOGIN_FAIL',
          payload: error.response?.data.errorMessage
        });
        toast.error(error.response?.data.errorMessage, {
          ...toastConfig,
          autoClose: 3000
        });
      }
    }
  };

  return (
    <>
      <Form.Group className="mb-3 text-start">
        <Form.Label htmlFor="email">Email address</Form.Label>
        <div className="form-icon-container">
          <Form.Control
            id="email"
            type="email"
            className="form-icon-input"
            placeholder="name@example.com"
            value={email}
            onChange={e => {
              setEmail(e.target.value);
            }}
          />
          <FontAwesomeIcon icon={faUser} className="text-body fs-9 form-icon" />
        </div>
      </Form.Group>
      <Form.Group className="mb-3 text-start">
        <Form.Label htmlFor="password">Password</Form.Label>
        <div className="form-icon-container">
          <Form.Control
            id="password"
            type="password"
            className="form-icon-input"
            placeholder="Password"
            value={password}
            onChange={e => {
              setPassword(e.target.value);
            }}
          />
          <FontAwesomeIcon icon={faKey} className="text-body fs-9 form-icon" />
        </div>
      </Form.Group>
      <Button variant="primary" className="w-100 mb-3" onClick={() => void handleSubmit()}>
        Sign In
      </Button>
      <p className="text-body-secondary fs-9 mb-0 text-center">
        Supplier agent? Use the{' '}
        <a href="https://supplier.kjauto.ph" target="_blank" rel="noreferrer">
          supplier portal
        </a>
        .
      </p>
    </>
  );
};

export default SignInForm;
